import React from 'react';
import Typography from '@mui/material/Typography';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import CompanyInfoCard from './CompanyInfoCard';

/**
 * Resumo de um toque: "google / cpc", "Google Ads (gclid)", o site de onde veio ou "Direto".
 */
export function describeSignupTouch(touch) {
  if (!touch) return '—';
  if (touch.utm_source) {
    return touch.utm_medium ? `${touch.utm_source} / ${touch.utm_medium}` : touch.utm_source;
  }
  if (touch.gclid || touch.gbraid || touch.wbraid) return 'Google Ads (clique)';
  if (touch.referrer) {
    try {
      return new URL(touch.referrer).hostname;
    } catch (e) {
      return touch.referrer;
    }
  }
  return 'Direto';
}

const sameTouch = (a, b) => JSON.stringify(a || {}) === JSON.stringify(b || {});

/**
 * CompanySignupOriginCard - de onde veio o cadastro (Admin Geral > empresa).
 * Primeiro toque em destaque; o último toque só aparece quando é outra campanha.
 * @param {Object} props
 * @param {{ first?: Object, last?: Object }|null} props.attribution
 */
function CompanySignupOriginCard({ attribution }) {
  const first = attribution?.first || null;
  const last = attribution?.last || null;

  const rows = attribution
    ? [
        { label: 'Origem', value: describeSignupTouch(first) },
        first?.utm_campaign && { label: 'Campanha', value: first.utm_campaign },
        first?.utm_term && { label: 'Termo', value: first.utm_term },
        first?.landing_path && { label: 'Entrada', value: first.landing_path },
        last && !sameTouch(first, last) && {
          label: 'Último toque',
          value: [describeSignupTouch(last), last.utm_campaign].filter(Boolean).join(' · '),
        },
      ].filter(Boolean)
    : [{ label: 'Origem', value: 'Não registrada' }];

  return (
    <CompanyInfoCard
      icon={<TravelExploreOutlinedIcon fontSize="small" />}
      title="Origem do cadastro"
      rows={rows.map((row) => ({
        ...row,
        value: (
          <Typography component="span" variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
            {row.value}
          </Typography>
        ),
      }))}
    />
  );
}

export default CompanySignupOriginCard;
